export default __webpack_public_path__ + "static/media/landing-write-story.c600d0ea.svg";